import {useMemo} from 'react';
import {useUnitsListStore} from '../../store/useUnitsListStore';
import {TELEMEDICINE_INFO} from '../../constants/telemedicineInfo';
import {Units} from '../../store/useUnitsListStore/types';
import {textHandle} from 'presentation/utils/textHandle';

export const useFilteredNetworkList = (query: string) => {
	const unitsList = useUnitsListStore(state => state.unitsList);

	const filteredList = useMemo(() => {
		if (!unitsList || !unitsList.units) return unitsList;

		const formattedQuery = textHandle(query).sanitizeText();

		if (!formattedQuery) return unitsList;

		const unitByLocalityFormatted =
			unitsList.units.unitsByLocality?.map(unit => ({
				...unit,
				name:
					unit?.name?.toLowerCase() === TELEMEDICINE_INFO.name.toLowerCase()
						? TELEMEDICINE_INFO.label.toLowerCase()
						: unit.name,
			})) || [];

		const filterUnits = (units: Units[]) =>
			units?.filter(unit => textHandle(unit?.name).sanitizeText().includes(formattedQuery)) ||
			[];

		return {
			...unitsList,
			units: {
				unitsByLocality: filterUnits(unitByLocalityFormatted),
				unitsByDistance: filterUnits(unitsList.units.unitsByDistance),
				unitsSupportAccredited: filterUnits(unitsList.units.unitsSupportAccredited),
			},
		};
	}, [unitsList, query]);

	return filteredList;
};
